import Axis from "util/table/Axis";
import Matrix from "util/table/Matrix";
import Table from "util/table/Table";

/**
 * A factory class that can be used to create a table out of an object from the speedweaver api
 */
export default class TableFactory {
    /**
     * Creates a table
     * @param {object} obj - object from api representing a table
     * @param {string} obj.type - the dimension of the table ("single", "1d", "2d", "3d")
     * @param {object} [obj.xAxis] - x axis data
     * @param {object} [obj.yAxis] - y axis data
     * @param {object} obj.dataAxis - z axis data
     */
    static createTable ({type, xAxis, yAxis, dataAxis, ...metaData}){
        //todo check for correct combination of axes for dimension

        if (xAxis) xAxis = new Axis({
            ...xAxis,
            matrix: new Matrix(xAxis)
        });

        if (yAxis) yAxis = new Axis({
            ...yAxis,
            matrix: new Matrix(yAxis)
        });

        if (dataAxis) dataAxis = new Axis({
            ...dataAxis,
            matrix: new Matrix(dataAxis)
        });

        const dimension = ["single", "1d", "2d", "3d"].indexOf(type);

        return new Table({dimension, xAxis, yAxis, dataAxis, ...metaData});
    }
}